var $7ae7985d84009e3a$exports = {};
$7ae7985d84009e3a$exports = {
    "loading": `A carregar...`,
    "placeholder": `Selecionar\u{2026}`
};


export {$7ae7985d84009e3a$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
